<template>
  <v-stepper v-model="e1">
    <v-stepper-header>
      <v-stepper-step :complete="e1 > 1" step="1">Select event</v-stepper-step>

      <v-divider></v-divider>

      <v-stepper-step :complete="e1 > 2" step="2">Administrator</v-stepper-step>

      <v-divider></v-divider>

      <v-stepper-step :complete="e1 > 3" step="3">Edit</v-stepper-step>
    </v-stepper-header>

    <v-stepper-items>
      <v-stepper-content step="1">
        <v-col>
          <v-data-iterator
            :items="items"
            :items-per-page.sync="itemsPerPage"
            :page="page"
            :search="search"
            :sort-by="sortBy.toLowerCase()"
            :sort-desc="sortDesc"
            hide-default-footer
          >
            <template v-slot:header>
              <v-toolbar dark color="blue darken-3" class="mb-1">
                <v-text-field
                  v-model="search"
                  clearable
                  flat
                  solo-inverted
                  hide-details
                  prepend-inner-icon="mdi-search"
                  label="Search"
                ></v-text-field>
              </v-toolbar>
            </template>

            <template v-slot:default="props">
              <v-row>
                <v-col v-for="(item, i) in props.items" :key="i" cols="12">
                  <v-card :color="item.Color" dark>
                    <div class="d-flex flex-no-wrap justify-space-between">
                      <div>
                        <v-card-title class="subheading font-weight-bold">
                          {{ item.Event }} / {{item.EventDescription}}
                          <div v-if="item.IsOpen">
                            <v-btn
                              class="mx-2"
                              color="primary"
                              dark
                              small
                              :outlined="item.Outlined"
                              @click="setSelectedEvent(item)"
                            >
                              Select {{item.Event}}
                              <v-icon small right>fa-lock-open</v-icon>
                            </v-btn>
                          </div>
                          <div v-if="!item.IsOpen">
                            <v-btn
                              class="mx-2"
                              color="primary"
                              dark
                              small
                              :outlined="item.Outlined"
                              @click="setSelectedEvent(item)"
                            >
                              Select {{item.Event}}
                              <v-icon small right>fa-lock</v-icon>
                            </v-btn>
                          </div>
                        </v-card-title>
                        <!-- <v-card-subtitle
                          v-text="item.Action + ' on ' + item.Dato + ' ' + item.Tid + ' By ' + item.OpenedBy + ', Mobile: ' + item.OpenedByMID"
                        ></v-card-subtitle>-->
                      </div>
                    </div>
                  </v-card>
                </v-col>
              </v-row>
            </template>

            <template v-slot:footer>
              <v-row class="mt-2" align="center" justify="center">
                <span class="grey--text">Items</span>
                <v-menu offset-y>
                  <template v-slot:activator="{ on }">
                    <v-btn dark text color="primary" class="ml-2" v-on="on">
                      {{ itemsPerPage }}
                      <v-icon>mdi-chevron-down</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item
                      v-for="(number, index) in itemsPerPageArray"
                      :key="index"
                      @click="updateItemsPerPage(number)"
                    >
                      <v-list-item-title>{{ number }}</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>

                <v-spacer></v-spacer>

                <span class="mr-4 grey--text">Page {{ page }} of {{ numberOfPages }}</span>
                <v-btn fab dark color="blue darken-3" class="mr-1" @click="formerPage">
                  <v-icon>mdi-chevron-left</v-icon>
                </v-btn>
                <v-btn fab dark color="blue darken-3" class="ml-1" @click="nextPage">
                  <v-icon>mdi-chevron-right</v-icon>
                </v-btn>
              </v-row>
            </template>
          </v-data-iterator>
        </v-col>

        <!-- <v-data-table
            :headers="headers"
            :items="events"
            :search="search"
            dense
            :loading="loading"
            loading-text="Loading... Please wait"
          >
            <template v-slot:item.IsOpen="{ item }">
              <div v-if="item.IsOpen">
                <v-chip class="mx-2" color="green" dark fab small @click="setSelectedEvent(item)">
                  <v-icon small>fa-lock-open</v-icon>
                </v-chip>
              </div>
              <div v-if="!item.IsOpen">
                <v-chip class="mx-2" color="red" dark fab small @click="setSelectedEvent(item)">
                  <v-icon small>fa-lock</v-icon>
                </v-chip>
              </div>
            </template>
            <template v-slot:item.Ant="{ item }">
              <v-chip dark min-width="20" hint="Checked in pilots">{{ item.Ant }}</v-chip>
            </template>
        </v-data-table>-->

        <ul v-if="errors && errors.length">
          <li v-for="error of errors" :key="error.id" style="color:Red;">{{error.message}}</li>
        </ul>
        <!-- </v-card> -->

        <v-text-field
          v-model="selectedEventText"
          :value="selectedEventText"
          placeholder="Select event"
          solo
          dense
          :prepend-inner-icon="prependIcon"
          readonly
        ></v-text-field>
        <!-- </v-row> -->
        <v-row>
          <v-col>
            <v-btn
              color="primary"
              @click="e1 = 2"
              :disabled="!continueEnabled1"
              :class="`d-flex justify-space-around mb-6`"
            >Continue</v-btn>
          </v-col>
          <v-col>
            <v-btn text :to="cancellink.to" :class="`d-flex justify-space-around mb-6`">Cancel</v-btn>
          </v-col>
        </v-row>
      </v-stepper-content>

      <v-stepper-content step="2">
        <v-text-field
          v-model="selectedEventText"
          :value="selectedEventText"
          solo
          dense
          :prepend-inner-icon="prependIcon"
          readonly
        ></v-text-field>

        <v-card>
          <v-text-field
            v-model="search2"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
          <v-card-title>
            Select administrator
            <v-spacer></v-spacer>
            <!-- <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field>-->
          </v-card-title>
          <v-data-table
            :headers="headers2"
            :items="eventopeners"
            :search="search2"
            dense
            :loading="loading2"
            loading-text="Loading... Please wait"
            hide-default-footer
            disable-pagination
          >
            <template v-slot:item.IsAdmin="{ item }">
              <!-- <v-col :class="`d-flex justify-space-around mb-4`"> -->
              <v-btn
                color="green"
                dark
                small
                min-width="100"
                :class="`d-flex justify-space-around mb-4`"
                @click="setEventAdmin(item)"
                :outlined="item.Outlined"
                :disabled="!item.IsAdmin"
              >Select</v-btn>
              <!-- </v-col> -->
            </template>
          </v-data-table>
          <ul v-if="errors3 && errors3.length">
            <li v-for="error of errors3" :key="error.id" style="color:Red;">{{error.message}}</li>
          </ul>
        </v-card>
        <v-text-field
          v-model="selectedAdminText"
          :value="selectedAdminText"
          placeholder="Select user"
          solo
          dense
          readonly
        ></v-text-field>
        <v-form v-model="isValid">
          <v-text-field
            v-model="ac"
            outlined
            required
            prepend-inner-icon="mdi-lock-question"
            placeholder="Access code"
            :rules="acRules"
            hint="Your access code"
            :append-icon="eyevalue ? 'mdi-eye' : 'mdi-eye-off'"
            @click:append="() => (eyevalue = !eyevalue)"
            :type="eyevalue ? 'password' : 'text'"
          ></v-text-field>
          <v-row>
            <v-col></v-col>
            <v-col>
              <v-btn
                :disabled="!isValid || !openerSelected"
                color="primary"
                @click="getAcValid(selectedAdminRegId)"
                :class="`d-flex justify-space-around mb-6`"
              >Validate</v-btn>
            </v-col>
            <!-- <v-col>
              <v-btn
                color="lightgrey"
                link
                :to="cancellink.to"
                :class="`d-flex justify-space-around mb-6`"
              >{{cancelBtnText}}</v-btn>
            </v-col>-->
            <v-col></v-col>
          </v-row>
          <v-alert type="success" :value="isAlertVisible">
            {{statusResultMsg}} .
            <v-btn
              small
              color="primary"
              @click="gotoStep3()"
            >Continue</v-btn>
          </v-alert>
          <v-alert type="error" :value="isWarningAlertVisible">{{statusResultMsg}}</v-alert>
        </v-form>
        <v-row>
          <v-col>
            <!-- <v-btn
              color="primary"
              @click="e1 = 3"
              :disabled="!continueEnabled2"
              :class="`d-flex justify-space-around mb-6`"
            >Continue</v-btn>-->
          </v-col>
          <v-col>
            <v-btn text :to="cancellink.to" :class="`d-flex justify-space-around mb-6`">Cancel</v-btn>
          </v-col>
        </v-row>
      </v-stepper-content>

      <v-stepper-content step="3">
        <v-text-field
          v-model="selectedEventText"
          :value="selectedEventText"
          solo
          dense
          :prepend-inner-icon="prependIcon"
          readonly
        ></v-text-field>
        <v-card>
          <v-card-title>
            <!-- <div v-if="this.selectedEvent.IsOpen">
            Select text on closing
            </div>
            <div v-if="!this.selectedEvent.IsOpen">
            Select text on opening
            </div>-->
            Add or delete users role
            <v-spacer></v-spacer>
            <!-- <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field>-->
          </v-card-title>
          <v-data-table
            :headers="headers3"
            :items="eventopeners"
            :search="search"
            dense
            :loading="loading2"
            loading-text="Loading... Please wait"
            hide-default-footer
          >
            <template v-slot:item.IsAdmin="{ item }">
              <v-btn
                :color="item.Color"
                dark
                rounded
                x-small
                min-width="100"
                :class="`d-flex justify-space-around mb-4`"
                @click="deleteUserFromRole(item)"
                :outlined="item.Outlined"
              >
                <v-icon x-small>fa-trash-alt</v-icon>
              </v-btn>
            </template>
          </v-data-table>
          <ul v-if="errors2 && errors2.length">
            <li v-for="error of errors2" :key="error.id" style="color:Red;">{{error.message}}</li>
          </ul>
        </v-card>
        <v-alert type="success" :value="isAlertVisible">
          {{statusResultMsg}}
          <v-btn small color="primary" @click="getEventOpeners(selectedEvent)">Refresh</v-btn>
        </v-alert>
        <v-alert type="error" :value="isWarningAlertVisible">{{statusResultMsg}}</v-alert>
        <div v-if="showUserSearch">
          <UserApiSearch @selected-regid="setRegId"></UserApiSearch>
          <!-- <p>{{ radios || 'null' }}</p> -->
          <v-row align="center" justify="center">
            <v-col cols="4">
              <v-radio-group v-model="radios" :mandatory="true" small>
                <v-radio label="Opener" value="3"></v-radio>
                <v-radio label="Administrator" value="2"></v-radio>
              </v-radio-group>
            </v-col>
            <v-col cols="3">
              <v-btn
                color="primary"
                small
                rounded
                @click="addUserToRole(addregId,radios)"
                :class="`d-flex justify-space-around mb-6`"
                :disabled="!addUserEnabled"
              >
                <!-- <v-icon small>Add</v-icon> -->
                Add
              </v-btn>
            </v-col>
          </v-row>
        </div>

        <v-row>
          <v-col>
            <v-btn
              color="primary"
              small
              @click="showUserSearch = true"
              :class="`d-flex justify-space-around mb-6`"
            >
              <v-icon small>fa-plus-circle</v-icon>
            </v-btn>
          </v-col>
          <v-col>
            <v-btn
              color="primary"
              small
              :to="cancellink.to"
              :class="`d-flex justify-space-around mb-6`"
            >Close</v-btn>
          </v-col>
        </v-row>
      </v-stepper-content>
    </v-stepper-items>
  </v-stepper>
</template>

<script>
import axios from "axios";
// import copybutton from "@/components/Copy.vue";
import UserApiSearch from "@/components/airbox/UserApiSearch.vue";

export default {
  data() {
    return {
      e1: 1,
      search: "",
      search2: "EventAdmin",
      loading: true,
      loading2: true,
      loading3: true,
      selectedEvent: null,
      selectedEventText: null,
      prependIcon: null,
      continueEnabled1: false,
      selectedAdminRegId: null,
      selectedAdmin: null,
      selectedAdminText: null,
      openerSelected: false,
      selectedEventComment: null,
      selectedEventCommentText: null,
      continueEnabled2: false,
      continueEnabled3: false,
      headers: [
        { text: "Event", value: "Event" },
        { text: "Description", value: "EventDescription" },
        { text: "Status", value: "IsOpen" },
        { text: "", value: "Ant" }
      ],
      events: [],
      eventcomments: [],
      items: [],
      errors: [],
      sortBy: "event",
      itemsPerPageArray: [10, 20, 40, 100],
      filter: {},
      sortDesc: false,
      page: 1,
      itemsPerPage: 10,
      keys: ["Event", "EventDescription", "Status"],
      headers2: [
        { text: "Name", value: "Name" },
        { text: "Select", value: "IsAdmin" },
        { text: "Mobile", value: "MID" },
        { text: "Role", value: "RoleName" }
      ],
      headers3: [
        { text: "Name", value: "Name" },
        { text: "Delete", value: "IsAdmin" },
        { text: "Mobile", value: "MID" },
        { text: "Role", value: "RoleName" }
      ],
      eventopeners: [],
      errors2: [],
      errors3: [],
      cancellink: { to: "/events" },
      isValid: true,
      statusResult: Number,
      statusResultMsg: String,
      isAlertVisible: false,
      isWarningAlertVisible: false,
      acRules: [v => !!v || "Access code is required"],
      ac: null,
      eyevalue: true,
      showUserSearch: false,
      addregId: Number,
      addUserEnabled: false,
      radios: 3
    };
  },

  created() {
    this.baseUrl = "https://pgapi.azurewebsites.net/dbapi/";
    // this.baseUrl = "http://localhost:3000/dbapi/";
    this.selectedEventText = null;
    this.selectedAdminText = null;
    this.selectedEventCommentText = null;
    this.continueEnabled1 = false;
    this.continueEnabled2 = false;
    this.ac = null;
    this.comment = null;
    axios
      // .get("http://jsonplaceholder.typicode.com/posts")
      //   .get("http://localhost:3000/dbapi/events")
      .get(this.baseUrl + "events")
      .then(response => {
        // JSON responses are automatically parsed.
        this.events = response.data;
        this.items = response.data;
        this.loading = false;
      })
      .catch(e => {
        this.errors.push(e);
      });
    // this.getEventOpeners(1);
  },

  computed: {
    numberOfPages() {
      return Math.ceil(this.items.length / this.itemsPerPage);
    },
    filteredKeys() {
      return this.keys.filter(key => key !== `Name`);
    }
  },
  methods: {
    nextPage() {
      if (this.page + 1 <= this.numberOfPages) this.page += 1;
    },
    formerPage() {
      if (this.page - 1 >= 1) this.page -= 1;
    },
    updateItemsPerPage(number) {
      this.itemsPerPage = number;
    },
    showAlert(a) {
      //console.log(a);
      // if (event.target.classList.contains("btn__content")) return;
      alert("Alert! \n" + a);
    },
    setSelectedEvent(event) {
      this.selectedEvent = event;
      this.selectedEventText = event.Event;
      if (event.IsOpen) {
        this.prependIcon = "fa-lock-open";
      } else {
        this.prependIcon = "fa-lock";
      }
      this.continueEnabled1 = true;
      this.getEventOpeners(event);

      // console.log(this.items)
      // console.log(event)

      var array = this.items;
      var id = event.Id;
      array.forEach(element => {
        element.Outlined = false;
      });
      this.items[id - 1].Outlined = true;
    },

    deleteUserFromRole(opener) {
    //   console.log(opener);
      var adminRegId = this.selectedAdmin.RegId;
      var ac = this.ac;
      var eventId = this.selectedEvent.EventId;
      var eventuserroleId = opener.EventUserRoleId;
      var toSubmit = JSON.stringify({ ac, eventId, eventuserroleId });
      const uri = this.baseUrl + "deleteeventrole/" + adminRegId;
    //   console.log(uri);
    //   console.log(toSubmit);
      this.isAlertVisible = false;
      this.isWarningAlertVisible = false;
      this.sendpost(uri, toSubmit, 1);
      //   this.getEventOpeners(this.selectedEvent);
    },

    addUserToRole(regId, roleId) {
      //   console.log(regId);
      var adminRegId = this.selectedAdmin.RegId;
      var ac = this.ac;
      var eventId = this.selectedEvent.EventId;
      //   var regId = regId;
      //   var roleId = roleId;
      var toSubmit = JSON.stringify({ ac, eventId, regId, roleId });
      const uri = this.baseUrl + "inserteventrole/" + adminRegId;
    //   console.log(uri);
    //   console.log(toSubmit);
      this.isAlertVisible = false;
      this.isWarningAlertVisible = false;
      this.showUserSearch = false;
      this.addUserEnabled = false;
      this.sendpost(uri, toSubmit, 1);
      //   this.getEventOpeners(this.selectedEvent);
    },

    getEventOpeners(event) {
      this.isAlertVisible = false;
      this.isWarningAlertVisible = false;
      var eventId = event.EventId;
      axios
        .get(this.baseUrl + "geteventroles/" + eventId)
        .then(response => {
          // JSON responses are automatically parsed.
          this.eventopeners = response.data;
          this.loading2 = false;
        })
        .catch(e => {
          this.errors2.push(e);
        });
    },
    setEventAdmin(opener) {
    //   console.log(opener);
      var id = opener.Id;
      this.selectedAdmin = opener;
      this.selectedAdminText = opener.Name;
      this.selectedAdminRegId = opener.RegId;
    //   console.log("Selected admin regid: ", this.selectedAdminRegId);

      var array = this.eventopeners;
      array.forEach(element => {
        element.Outlined = false;
      });
      this.eventopeners[id - 1].Outlined = true;
      this.openerSelected = true;
    },

    getAcValid() {
      var regId = this.selectedAdminRegId;
      var ac = this.ac;
      var toSubmit = JSON.stringify({ ac });
      const uri = this.baseUrl + "getacvalid/" + regId;
      //   console.log(uri)
      //   console.log(toSubmit)
      this.sendpost(uri, toSubmit, 1);
    },

    gotoStep3() {
      this.e1 = 3;
      this.isAlertVisible = false;
      this.isWarningAlertVisible = false;
    },

    setRegId(id) {
      this.addregId = id;
    //   console.log(id);
      this.addUserEnabled = true;
    },

    sendpost(uri, toSubmit, type) {
      const axiosConfig = {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*"
        }
      };
      axios
        .post(uri, toSubmit, axiosConfig)
        .then(response => {
          if (type === 0) {
            this.statusResult = response.data.Result;
            this.statusResultMsg = response.data.ResultMsg;
          } else {
            this.statusResult = response.data[0].Result;
            this.statusResultMsg = response.data[0].ResultMsg;
          }
          this.setAlert(this.statusResult);
          //   if (this.statusResult === 1) {
          //       getstatus();
          //   }
        })
        .catch(e => {
          this.errors.push(e);
          this.statusResult = 0;
          this.statusResultMsg = "Something went wrong!";
          this.setAlert(this.statusResult);
        });
    },

    setAlert(statusResult) {
      if (statusResult === 1) {
        this.isAlertVisible = true;
        this.isWarningAlertVisible = false;
      }
      if (statusResult === 0) {
        this.isWarningAlertVisible = true;
        this.isAlertVisible = false;
      }
    }
  },
  components: {
    UserApiSearch
    // copybutton
  }
};
</script>